import { type EnumType } from '@ncoderz/superenum';

const TextMarkType = {
  // Styles
  bold: 'bold',
  light: 'light',
  italic: 'italic',
  highlight: 'highlight',
  highlightOrange: 'highlightOrange',
  highlightYellow: 'highlightYellow',
  highlightGreen: 'highlightGreen',
  highlightBlue: 'highlightBlue',
  highlightPurple: 'highlightPurple',
  highlightPink: 'highlightPink',
  highlightBrown: 'highlightBrown',
  highlightBlack: 'highlightBlack',
  highlightWhite: 'highlightWhite',
  highlightGray: 'highlightGray',

  // Inline only styles
  strike: 'strike',
  subscript: 'subscript',
  superscript: 'superscript',
  ins: 'ins',
  del: 'del',
  underline: 'underline',
  doubleUnderline: 'doubleUnderline',
  smallcaps: 'smallcaps',
  circle: 'circle',
  languageEmRed: 'languageEmRed',
  languageEmOrange: 'languageEmOrange',
  languageEmYellow: 'languageEmYellow',
  languageEmGreen: 'languageEmGreen',
  languageEmBlue: 'languageEmBlue',
  languageEmPurple: 'languageEmPurple',
  languageEmPink: 'languageEmPink',
  languageEmBrown: 'languageEmBrown',
  languageEmBlack: 'languageEmBlack',
  languageEmWhite: 'languageEmWhite',
  languageEmGray: 'languageEmGray',
  languageEm: 'languageEm',
  userUnderline: 'userUnderline',
  userDoubleUnderline: 'userDoubleUnderline',
  userStrike: 'userStrike',
  userCircle: 'userCircle',
  userHighlight: 'userHighlight',
  notranslate: 'notranslate',

  // Attribute chain
  link: 'link',
  ref: 'ref',
  xref: 'xref',
  extref: 'extref',
  footnote: 'footnote',
  footnoteStar: 'footnote*',
  symbol: 'symbol',
  var: 'var',
  code: 'code',
  timer: 'timer',
  duration: 'duration', // legacy: no longer produced by the parser (>= 8.41.1), accepted as generator input
  color: 'color', // legacy: no longer produced by the parser (>= 8.41.1, now textStyle), accepted as generator input
  textStyle: 'textStyle',
  colorPicker: 'colorPicker',
  comment: 'comment',
} as const;

export type TextMarkTypeType = EnumType<typeof TextMarkType>;

export { TextMarkType };
